import { filter } from 'lodash'
import { UserLanguageCode } from '@/types'

/**
  Used to determine which of a user's browser languages are supported by the app

  If none of the passed languages are supported, 'en' will be returned
* */
export const pickSuitableLanguage = (preferredLanguages: string[]): UserLanguageCode => {

  const supportedLanguages = filter(preferredLanguages, (language): boolean => {
    return !!UserLanguageCode[language]
  })

  return supportedLanguages[0] as UserLanguageCode || UserLanguageCode.en
}
